/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Event_Metrics_Duration_TitleInputs */



/**
* | output |
* | --- |
* | "{duration} Seconds (Total Duration)" |
*
* @param {Event_Metrics_Duration_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_duration_title = /** @type {((inputs: Event_Metrics_Duration_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Duration_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.duration} Secondes (duree totale)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.duration} Sekunden (Gesamtdauer)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.duration} Secondi (Durata totale)`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.duration} секунд (общая продолжительность)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.duration} Segundos (Duración total)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.duration} 秒（总持续时间）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.duration} 秒（合計時間）`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.duration} सेकंड (कुल अवधि)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.duration} Segundos (Duração Total)`)
	return /** @type {LocalizedString} */ (`${i?.duration} Seconds (Total Duration)`)
});